export default __webpack_public_path__ + "static/media/Sleepiness.e2f6d9a9.svg";